import { render, staticRenderFns } from "./userComplaintList.vue?vue&type=template&id=dcdf15e8&scoped=true"
import script from "./userComplaintList.vue?vue&type=script&lang=js"
export * from "./userComplaintList.vue?vue&type=script&lang=js"
import style0 from "./userComplaintList.vue?vue&type=style&index=0&id=dcdf15e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf15e8",
  null
  
)

export default component.exports